import { useI18n } from "vue-i18n";

export type DynamicLabel =
  | string
  | {
      i18n: string | any[];
    };

export const useDyanmicI18n = () => {
  const { t } = useI18n();

  const dt = (dynamicLabel: DynamicLabel) => {
    if (typeof dynamicLabel === "string") {
      return dynamicLabel;
    }

    if (typeof dynamicLabel.i18n === "string") {
      return t(dynamicLabel.i18n);
    }

    type TArguments = Parameters<typeof t>;
    return t(...(dynamicLabel.i18n as TArguments));
  };

  return { dt };
};
